import formatNumber from '../../../../../../../../_dev/frontend/js/commonFunctions/formatNumber';

const pageProductPopupHandler = () => {
    //  Контролы
    const pageProductPopupControls = document.querySelectorAll('.page-product-popup-control-button');

    // Если контролов нет, функция не имеет смысла
    if (!pageProductPopupControls) return;

    // Функция заполнения полей товара
    const fillProductData = (key) => {
        const productPrice = {
            source: document.querySelector('.Product-page__current-price'),
            input: document.querySelectorAll('input[name="product-price"]'),
            description: document.querySelectorAll('.product-data-in-form-price')
        };
        const productColor = {
            source: document.querySelector('.Product-page__row[data-name="color"] select'),
            input: document.querySelectorAll('input[name="product-color"]'),
            description: document.querySelectorAll('.product-data-in-form-color')
        };
        const productSize = {
            source: document.querySelector('.Product-page__row[data-name="size"] input:checked'),
            input: document.querySelectorAll('input[name="product-size"]'),
            description: document.querySelectorAll('.product-data-in-form-size')
        };

        if (productColor.source) {
            productColor.input.forEach((el) => {
                el.value = productColor.source.options[productColor.source.selectedIndex].text;
            });
            productColor.description.forEach((el) => {
                el.innerText = productColor.source.options[productColor.source.selectedIndex].text;
            });
        }

        if (productSize.source) {
            productSize.input.forEach((el) => {
                el.value = productSize.source.nextElementSibling.innerText;
            });
            productSize.description.forEach((el) => {
                el.innerText = productSize.source.nextElementSibling.innerText;
            });
        }

        if (productPrice.source) {
            productPrice.input.forEach((el) => {
                el.value = productPrice.source.dataset.price;
            });
            productPrice.description.forEach((el) => {
                el.innerText = `${formatNumber(productPrice.source.dataset.price)} ₽`;
            });
        }

        const tbankDescription = document.querySelectorAll('input.payform-tbank-row[name="description"]');
        const tbankAmount = document.querySelectorAll('input.payform-tbank-row[name="amount"]');
        const tbankReceipt = document.querySelectorAll('input.payform-tbank-row[name="receipt"]');
        let tbankDescriptionOptions = '';

        if (tbankDescription)  {
            tbankDescription.forEach((el) => {
                const nameAndId = el.getAttribute('data-title-and-id');
                el.value = '';
                el.value = nameAndId;
            });
        }

        const productOptionsInputs = document.querySelectorAll('input[name="product-options"]');
        const productSelectOptions = document.querySelectorAll('.option-select');
        const productSelectRadios = document.querySelectorAll('.option-radio input[type="radio"]:checked');

        if (productOptionsInputs) {
            // Массив для всех опций
            let optionsArray = [];

            if (productSelectOptions) {
                productSelectOptions.forEach((select) => {
                    const optId = select.getAttribute('data-opt-id');
                    const optName = select.getAttribute('data-opt-name');
                    const optType = select.getAttribute('data-opt-type');
                    const pOptId = select.getAttribute('data-p-opt-id');
                    const selectedOption = select.options[select.selectedIndex];
                    const pOptValId = selectedOption.getAttribute('data-p-opt-val-id');
                    const pOptVal = selectedOption.getAttribute('data-p-opt-val');

                    // Добавляем объект с данными опции в массив
                    optionsArray.push({
                        opt_id: optId,
                        opt_name: optName,
                        opt_type: optType,
                        p_opt_id: pOptId,
                        p_opt_val_id: pOptValId,
                        p_opt_val: pOptVal
                    });

                    const lastChar = tbankDescriptionOptions.charAt(tbankDescriptionOptions.length - 1);
                    if (lastChar != '.') {
                        tbankDescriptionOptions += `; ${optName} — ${pOptVal}`;
                    }
                });
            }

            if (productSelectRadios) {
                productSelectRadios.forEach((radio) => {
                    if (radio.checked) { // Проверяем, выбрано ли радио
                        const optId = radio.getAttribute('data-opt-id');
                        const optName = radio.getAttribute('data-opt-name');
                        const optType = radio.getAttribute('data-opt-type');
                        const pOptId = radio.getAttribute('data-p-opt-id');
                        const pOptValId = radio.getAttribute('data-p-opt-val-id');
                        const pOptVal = radio.getAttribute('data-p-opt-val');

                        // Добавляем объект с данными опции в массив
                        optionsArray.push({
                            opt_id: optId,
                            opt_name: optName,
                            opt_type: optType,
                            p_opt_id: pOptId,
                            p_opt_val_id: pOptValId,
                            p_opt_val: pOptVal
                        });

                        const lastChar = tbankDescriptionOptions.charAt(tbankDescriptionOptions.length - 1);
                        if (lastChar != '.') {
                            tbankDescriptionOptions += `; ${optName} — ${pOptVal}`;
                        }
                    }
                });
            }

            tbankDescriptionOptions += '.';

            // Преобразуем массив в строку JSON
            const optionsValue = JSON.stringify(optionsArray);

            // Устанавливаем значение в скрытый input
            productOptionsInputs.forEach((i) => {
                i.value = optionsValue;
            });
        }

        if (tbankDescription && tbankAmount) {
            tbankDescription.forEach((el) => {
                let value = el.value;
                value += tbankDescriptionOptions;
                el.value = value;
            });

            tbankAmount.forEach((el) => {
                if (productPrice.source) {
                    el.value = productPrice.source.dataset.price;
                }
            });
        }
    }

    // Открытие и закрытие окон
    pageProductPopupControls.forEach((el) => {
        const target = document.getElementById(el.dataset.target);
        el.addEventListener('click', (e) => {
            e.preventDefault();
            if (target.classList.contains('--is-visible')) {
                target.classList.remove('--is-visible');
            } else {
                fillProductData();
                target.classList.add('--is-visible');
            }
        });
    });
}

export default pageProductPopupHandler;
